import { v4 as uuidv4 } from "uuid";
import ImportedInvoiceItemGrid from "./ImportedInvoiceItemGrid";
import ImportedInvoiceItemGridPluginSettings from "./ImportedInvoiceItemGridPluginSettings";
import i18n from "../../../i18n";

export const ImportedInvoiceItemTab = (): ITab => {
    return {
        id: uuidv4(),
        title: i18n.t("documents.invoice.invoiceItemsPositionTabTitle"),
        view: {
            content: ImportedInvoiceItemGridPluginSettings
                ? <ImportedInvoiceItemGrid gridId={uuidv4()} plugin={ImportedInvoiceItemGridPluginSettings} />
                : <p> {i18n.t("general.directoryNotConfigured")} </p>
        }
    };
};

export default ImportedInvoiceItemTab;
